import { FC, React, useContext, useMemo} from 'external/react'
import { TeacherContext } from 'teacher/context'
import { InputField } from 'components/common/InputField'

type GeneralInfoFieldProps = {
  id: string
  Component?: FC<any>
  required?: boolean
  readonlyValue?: string
  className?: string
}

const GeneralInfoField: FC<GeneralInfoFieldProps> = props => {
  const {id, Component = InputField, required, readonlyValue} = props

  const context = useContext(TeacherContext) as any 
  const {newPlan, updateState, translate} =  context

  const updateContent = (value: string) => { !readonlyValue && updateState({newPlan: {content: {[id]: {$set: value}}}}) }

  const value = useMemo(() => (
    readonlyValue
      ? readonlyValue
      : newPlan.content
        ? newPlan.content[id] || ''
        : '' 
  ), [id, newPlan.content, readonlyValue])

  return (
    <Component
         label={translate(`planning-rd-general-info-field-label-${id}`)}
         onChange={updateContent}
         required={required}
         readonly={readonlyValue ? true : undefined}
         value={value}
    />
  )
}

export {GeneralInfoField as default}